import CryptoJS from 'crypto-js';

const keys = '@3M5vDua'; // Replace with your secret key

export function encryptJson(jsonObject) {
  const jsonString = JSON.stringify(jsonObject);
  return CryptoJS.AES.encrypt(jsonString, keys).toString();
}

export function decryptJson(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, keys);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedString);
}